module.exports = __webpack_public_path__ + "static/portfolio2a-488d6fa1caac93ec40cb2cf7ab8d326b.jpg";